<template>
  <div >
    <b-container>
      <b-card title="Task">
      <b-row>
          <b-col>
            <b-input-group prepend="API-Key">
              <b-form-input v-model="apiKey"></b-form-input>
            </b-input-group>
          </b-col>
      </b-row>
      <br>
      <b-row>
          <b-col>
            <b-input-group prepend="Task Id">
              <b-form-input v-model="taskId"></b-form-input>
            </b-input-group>
          </b-col>
      </b-row>
      <br>
      <b-row>
          <b-col>
            <b-btn variant="info" @click="loadOverview()">Ok</b-btn>
          </b-col>
      </b-row>
      <br>
      <b-row v-if="id">
        <b-col>
          <b-list-group flush>
              <b-list-group-item><b>Id</b>: {{id}}</b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <br>
      <b-row v-if="id">
        <b-col>
          <b-list-group flush>
              <b-list-group-item><b>creationDate</b>: {{creationDate}}</b-list-group-item>
              <b-list-group-item><b>checkDate</b>: {{checkDate}}</b-list-group-item>
              <b-list-group-item><b>lockedUntil</b>: {{lockedUntil}}</b-list-group-item>
              <b-list-group-item><b>service</b>: {{service}}</b-list-group-item>
        </b-list-group>
        </b-col>
        <b-col>
          <b-list-group flush>
              <b-list-group-item><b>state</b>: {{state}}</b-list-group-item>
              <b-list-group-item><b>retries</b>: {{retries}}</b-list-group-item>
              <b-list-group-item><b>period</b>: {{period}}</b-list-group-item>
              <b-list-group-item><b>startId</b>: {{startId}}</b-list-group-item>
        </b-list-group>
        </b-col>
        
      </b-row>
      </b-card>
      <br>
       <b-row>
          <b-col>
            <b-table bordered :items="instructions" :fields="fields">
              
            </b-table>
          </b-col>
      </b-row>
      
      
    </b-container>
    
     
    <v-dialog/>
  </div>

</template>

<script>
var CryptoJS = require("crypto-js");
export default {
  name: 'Task',
  data () {
    return {
      apiKey: '',
      taskId:  '',
      id: undefined,
      state: undefined,
      retries: undefined,
      checkDate: undefined,
      creationDate: undefined,
      lockedUntil: undefined,
      period: undefined,
      startId: undefined,
      instructions: [],
      fields: ["id", "subject", "recipient", "method", "url"]
    }
  },
  created: function () {
    this.apiKey = this.$route.params.apiKey;
    this.taskId = this.$route.params.id;
    if(this.isBlank(this.apiKey)){
      this.apiKey = this.$route.query.apiKey;
    }
    if(this.isBlank(this.taskId)){
      this.taskId = this.$route.query.id;
    }
    if(!this.isBlank(this.apiKey) && !this.isBlank(this.taskId)){
      this.loadOverview();
    } 
  },
  // methods that implement data logic.
  methods: {
    isBlank: function (str) {
		  return (!str || /^\s*$/.test(str));
    },
    loadOverview : function() {
      let view = this;
      let url = '/api/task'
      url = this.appendParam("id", this.taskId, url, '/api/task');
      
      let method = "GET";
      let turl = url.replace(/^.*\/\/[^\/]+/, '');
      let apipath = turl.substring(url.indexOf('/api'));
      let timestamp = (new Date()).getTime();
      
      // create signature
      var signature = [method, apipath, timestamp].join(',');
      
      // hash and base64 encode it
      let hash = CryptoJS.HmacSHA1(signature, this.apiKey).toString(CryptoJS.enc.Base64);

      axios({
        method: 'get',
        headers: {
          'x-api-key': hash,
          'x-api-key-timestamp': timestamp
        },
        url: url
      }).then(response => {
        view.setOverview(response.data);
				
		  }).catch(function (error) {
				view.toggleModal('Fehler', '<p>Daten konnten nicht geladen werden.</p>');
				
		  })
			
    },
    appendParam(name, param, url, baseUrl){
      if(!this.isBlank(param)){
        if(url == baseUrl){
          url+="?"+name+"="+param;
        } else {
          url+="&"+name+"="+param;
        }
      }
      return url;
    },
    setOverview: function(data) {
      this.id = data.id;
      this.state = data.state;
      this.service = data.service;
      this.retries = data.retries;
      this.checkDate = data.checkDate;
      this.creationDate = data.creationDate;
      this.lockedUntil = data.lockedUntil;
      this.period = data.period;

      let instructionSet = data.instructions;
      this.startId = instructionSet.startId;
      
      let overviewA = [];
      let dict = instructionSet.instructionMap;
      for (var key in dict) {
          if (dict.hasOwnProperty(key)) {
            let instructionItem = {
                id: dict[key].id,
                subject: dict[key].subject,
                recipient: dict[key].recipient,
                method: dict[key].method,
                url: dict[key].url
            }
            overviewA.push(instructionItem);
          }
      }

      this.instructions = overviewA;
    },
    toggleModal(title, text) { 
			this.$modal.show('dialog', {
				title: title,
				text: text,
				buttons: [
					{
						title: 'OK',
						handler: () => {
							this.$modal.hide('dialog')
						}
					}
				]
			}) 
		}
  },
  watch: {
		'$route' (to, from) {
			this.apiKey = to.params.apiKey;
      this.taskId = to.params.id;
      if(!this.isBlank(this.apiKey) && !this.isBlank(this.taskId)){
        this.loadOverview();
      } 
		}
  },
  components: {
  },
  computed: {
   
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
